import React from "react";
import { useHistory } from "react-router-dom";
import NiceModal, { useModal } from "@ebay/nice-modal-react";
import PlanOptions from "./PlanOptions";
import "./styles.scss";
import KC_Modal_2 from "../../../designsystem/KC_Modal/KC_Modal_2";
import KC_Heading3 from "../../../designsystem/typography/KC-Heading/KC_Heading3";
import { tt } from "../../../utils/i18n/i18n";
import SubscriptionPlanDTO, {
  SubscriptionPlanType
} from "@tootsweet/model/datatransfer/SubscriptionPlanDTO";
import { SIGNUP, SUBSCRIPTION } from "../../../utils/routes/routes";
import { useAccountToDisplaySelector } from "../../../redux/actions/user";
import { buildPathWithTrackingId } from "../../../utils/routing/routingUtils";
import ManagedAccount from "@tootsweet/model/entities/ManagedAccount";

interface Props {
  isForNewVenue?: boolean;
  onPlanClick?: (plan: SubscriptionPlanDTO, commitment: string) => void;
  customTitle?: string;
  hideEnterprise?: boolean;
}

export interface PlanSelection {
  plan: SubscriptionPlanDTO;
  commitment: string;
}

const PlanOptionModal = NiceModal.create((props: Props) => {
  const modal = useModal();
  const { accountToDisplay } = useAccountToDisplaySelector();
  const history = useHistory();

  const handleClose = () => {
    modal.resolve(null);
    void modal.hide();
  };

  const handlePlanClick = (plan: SubscriptionPlanDTO, commitment: string) => {
    if (props.isForNewVenue) {
      modal.resolve({ plan, commitment });
      void modal.hide();
      return;
    }

    if (props.onPlanClick) {
      props.onPlanClick(plan, commitment);
      void modal.hide();
      return;
    }

    // Default behavior: navigate to subscription page
    if (!accountToDisplay) {
      alert(tt("error"));
      return;
    }

    navigateToPlanSubscription(accountToDisplay, history, plan, commitment);
    void modal.hide();
  };

  return (
    <KC_Modal_2
      id="upgrade-plan-modal"
      isOpen={modal.visible}
      onClose={handleClose}
      className="plan-option-modal"
      header={
        <div className="mt-2">
          <KC_Heading3
            text={
              props.customTitle ??
              (props.isForNewVenue
                ? tt("new_venue_select_plan")
                : tt("upgrade_plan"))
            }
            primary={false}
            secondary={false}
          />
        </div>
      }
    >
      <PlanOptions
        onPlanClick={handlePlanClick}
        showCurrentPlan={!props.isForNewVenue}
        hideEnterprise={props.hideEnterprise}
        hideFree={props.isForNewVenue}
      />
    </KC_Modal_2>
  );
});

export default PlanOptionModal;

function navigateToPlanSubscription(
  accountToDisplay: ManagedAccount,
  history: any,
  plan: SubscriptionPlanDTO,
  commitment: string
): void {
  if (!accountToDisplay?.trackingID) {
    alert(tt("error"));
    return;
  }

  const planType = plan.type as SubscriptionPlanType;
  const planId = plan._id.toString();

  if (planType === SubscriptionPlanType.ENTERPRISE) {
    window.open(
      "https://calendly.com/d/cnwv-bwk-8mr/demande-de-devis-kadow-club",
      "_blank"
    );
  } else if (planType === SubscriptionPlanType.FREE) {
    history.push(buildPathWithTrackingId(SIGNUP, accountToDisplay.trackingID));
  } else {
    history.push(
      buildPathWithTrackingId(
        SUBSCRIPTION,
        accountToDisplay.trackingID,
        false,
        {
          planId,
          duration: commitment
        }
      )
    );
  }
}
